import { observable, action } from 'mobx';

class LabWebApplicationsStore {
  @observable expandedPanels = new Set<string>();

  @action togglePanels = (id: string, expanded: boolean) =>
    expanded ? this.expandedPanels.add(id) : this.expandedPanels.delete(id);
}

export default LabWebApplicationsStore;
